/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from "react";
import Web3 from "web3";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import {connect} from "react-redux";
import {TODO_LIST_ABI, TODO_LIST_ADDRESS} from "./config";
import TodoList from "./TodoList";
import _ from "lodash";
import {login, register} from "./Redux/actions/user";
import {Redirect, Link} from "react-router-dom";
const optionsMusic = [
  {value: "compas", label: "Compas"},
  {value: "vodou", label: "Vodou"},
  {value: "raboday", label: "Raboday"},
  {value: "rnb", label: "RNB"},
  {value: "afro", label: "Afro"},
  {value: "raggae", label: "Raggae"},
];

const optionsArt = [
  {value: "arts visuels", label: "Arts visuels"},
  {value: "litteraires", label: "littéraires"},
  {value: "arts du spectacle", label: "Arts du spectacle"},
];

const typeActivite = [
  {value: "musique", label: "Musique"},
  {value: "artistique", label: "Artistique"},
];

class App extends Component {
  componentWillMount() {
    //this.loadBlockchainData();
  }
  state = {tasks: []};

  async loadBlockchainData() {
    const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
    const accounts = await web3.eth.getAccounts();

    this.setState({account: accounts[0]});
    const todoList = new web3.eth.Contract(TODO_LIST_ABI, TODO_LIST_ADDRESS);
    this.setState({todoList});
    const taskCount = await todoList.methods.taskCount().call();
    this.setState({taskCount});
    for (var i = 1; i <= taskCount; i++) {
      let task = await todoList.methods.tasks(i).call();
      task.mainAuthor = JSON.parse(task.authors)[0].fullname;

      this.setState({
        tasks: [...this.state.tasks, task],
      });
    }

    this.setState({loading: false});

    console.log(this.state.account);
  }

  constructor(props) {
    super(props);
    this.state = {
      account: "",
      taskCount: 0,
      tasks: [],
      loading: false,
      startDate: new Date(),
      user: this.props.user.user,
      fname: "",
      lname: "",
      psedo: "",
      birthDate: new Date(),
      email: "",
      password: "",
      phone: "",
      nationalId: "",
      patenteId: "",
      activity: "",
      category: [],
      stats: [],
    };

    this.createTask = this.createTask.bind(this);
    this.toggleCompleted = this.toggleCompleted.bind(this);
  }

  createTask(title, category, contents, authors) {
    this.setState({loading: true});

    let date = new Date().toString();
    this.state.todoList.methods
      .createTask(title, category, contents, authors, date)
      .send({from: this.state.account})
      .once("receipt", () => {
        //let tsk = receipt.events.TaskCreated.returnValues;
        // console.log(receipt.events.TaskCreated.returnValues);

        this.setState(
          {
            loading: false,
            // tasks: [
            //   ...this.state.tasks,
            //   {id: tsk.id, content: tsk.content, completed: tsk.completed},
            // ],
          },
          () => {
            window.location.reload();
          }
        );
      });
  }

  toggleCompleted(taskId) {
    this.setState({loading: true});
    this.state.todoList.methods
      .toggleCompleted(taskId)
      .send({from: this.state.account})
      .once("receipt", (receipt) => {
        let tsk = receipt.events.TaskCompleted.returnValues;
        console.log(receipt);
        window.location.reload();
        this.state.tasks[taskId].completed = tsk.completed;
        this.setState({
          loading: false,
          tasks: this.state.tasks,
        });
      });
  }
  componentDidMount() {
    //console.log(this.props.stats);
  }
  handleChange = (date) => {
    this.setState(
      {
        birthDate: date,
      },
      () => {
        // this.nextPrev(new Date(date));
      }
    );
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.props.user !== prevProps.user) {
      window.location.reload();
    }
  }

  setStats = () => {
    let radios = [
      {value: "280319", label: "Trace FM Haiti"},
      {value: "235480", label: "Magik9 100.9 FM"},
    ];

    var now = new Date();
    localStorage.setItem("lastupdate", now.toDateString());

    for (let r = 0; r < radios.length; r++) {
      const rad = radios[r];

      for (var d = new Date(2020, 6, 4); d <= now; d.setDate(d.getDate() + 1)) {
        this.listen(rad.value, new Date(d), this.props.user.user.username, "");
      }
    }
  };

  listen = (radio, date, author, title) => {
    let self = this;

    let date_ =
      date.getFullYear() +
      "" +
      (date.getMonth() < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());

    axios
      .get(
        `https://cors-anywhere.herokuapp.com/https://api.acrcloud.com/v1/acrcloud-monitor-streams/${radio}/results?access_key=a54f67369a4ce05e49c8af7263f1831d&date=${date_}`
      )
      .then(function (response) {
        //console.log(self.filtre(response.data, author, title).length);

        var other = _.concat(
          self.state.stats,
          self.filtre(response.data, author, title)
        );
        self.setState({stats: other});
        console.log("add....");

        // _.concat(self.state.stats, self.filtre(response.data, author, title));
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  filtre = (arr, artist, title) => {
    return arr
      ? arr
          .filter((d) =>
            JSON.stringify(d.metadata.music[0].title)
              .toLowerCase()
              .includes(title.toLowerCase())
          )
          .filter((d) =>
            JSON.stringify(d.metadata.music[0].artists)
              .toLowerCase()
              .includes(artist.toLowerCase())
          )
      : [];
  };

  render() {
    if (
      this.props.user &&
      this.props.user.user &&
      this.props.user.user.role_user === "admin"
    ) {
      // window.location.href = "/dashboard";
      return <Redirect to={"/dashboard"} />;
    } else {
      return (
        <div class="main-page">
          {this.props.user && !this.props.user.jwt ? (
            <Main />
          ) : (
            <div>
              <main
                className="page-wrapper"
                style={{maxHeight: 100, minHeight: 40}}>
                <div
                  className="rn-slider-area position-relative"
                  id="home"
                  style={{marginTop: -0}}>
                  <div id="particles-js"></div>
                  <div
                    className="slide slide-style-2 bg_image bg_image--27 d-flex align-items-center justify-content-center"
                    style={{}}></div>
                </div>
              </main>

              <div className="container-fluid" style={{marginTop: 0}}>
                <div className="row">
                  <main
                    role="main"
                    className="col-lg-12 d-flex justify-content-center">
                    {this.state.loading ? (
                      <div id="loader" className="text-center">
                        <p className="text-center">Loading...</p>
                      </div>
                    ) : (
                      <TodoList
                        tasks={this.props.user.user.artworks}
                        createTask={this.createTask}
                        toggleCompleted={this.toggleCompleted}
                      />
                    )}
                  </main>
                </div>
              </div>
            </div>
          )}

          <div
            className="modal fade"
            id="loginModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="loginModalLabel"
            aria-hidden="true">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Connectez-vous
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="form-group">
                      <label
                        htmlFor="recipient-name"
                        className="col-form-label">
                        Email ou Nom d'artiste:
                      </label>
                      <input
                        id="email"
                        ref={(input) => {
                          this.email = input;
                        }}
                        type="text"
                        className="form-control"
                        placeholder="Email"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message-text" className="col-form-label">
                        Mot de passe:
                      </label>
                      <input
                        type="password"
                        id="pass"
                        ref={(input) => {
                          this.password = input;
                        }}
                        className="form-control"
                        placeholder="Password"
                        required
                      />
                    </div>
                    {this.state.loading === true ? (
                      <center>
                        <p style={{fontSize: 12}}>Connection en cours...</p>
                      </center>
                    ) : null}
                  </form>
                </div>
                {this.state.loading === false ? (
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal">
                      Fermer
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        // Request API.
                        this.setState({loading: true});
                        setTimeout(() => {
                          alert("Problème de connection avec le serveur");
                          this.setState({loading: false});
                        }, 15000);
                        this.props.login({
                          identifier: this.email.value,
                          password: this.password.value,
                        });
                      }}>
                      Connectez-vous
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <div
            className="modal bd-example-modal-lg"
            id="membreModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="membreModalLabel"
            data-backdrop="static">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="membreModalLabel">
                    Devenez membre
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="form-wrapper">
                    <form
                      onSubmit={(event) => {
                        event.preventDefault();
                        this.props.register({
                          username: this.state.psedo,
                          email: this.state.email,
                          firstName: this.state.fname,
                          lastName: this.state.psedo,
                          birthDate: this.state.birthDate,
                          nationalId: this.state.nationalId,
                          patenteId: this.state.patenteId,
                          type: this.state.activity,
                          categories: this.state.category,
                          password: this.state.password,
                          role_user: "author",
                        });
                      }}>
                      <div className="row">
                        <div className="col-lg-6  col-sm-12">
                          <label className="col-lg-12">
                            <input
                              id="Nom"
                              onChange={(input) => {
                                this.setState({fname: input.target.value});
                              }}
                              type="text"
                              className="form-control"
                              placeholder="Nom"
                              required
                              style={{height: 50}}
                            />
                          </label>
                          <label className="col-lg-12">
                            <input
                              id="Prenom"
                              onChange={(input) => {
                                this.setState({lname: input.target.value});
                              }}
                              type="text"
                              className="form-control"
                              placeholder="Prenom"
                              required
                              style={{height: 50}}
                            />
                          </label>
                          <label className="col-lg-12">
                            <input
                              id="NomArtiste"
                              onChange={(input) => {
                                this.setState({psedo: input.target.value});
                              }}
                              type="text"
                              className="form-control"
                              placeholder="Nom d'artiste ou du groupe"
                              required
                              style={{height: 50}}
                            />
                          </label>

                          <label className="col-lg-12">
                            <div className="row">
                              <div className="col-lg-6">
                                <p style={{color: "#aaa"}}>Date de naissance</p>
                              </div>
                              <div className="col-lg-6">
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  selected={this.state.birthDate}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </label>
                          <label className="col-lg-12">
                            <input
                              id="Email"
                              onChange={(input) => {
                                this.setState({email: input.target.value});
                              }}
                              type="email"
                              className="form-control"
                              placeholder="Email"
                              required
                              style={{height: 50}}
                            />
                          </label>
                          <label className="col-lg-12">
                            <input
                              id="password"
                              onChange={(input) => {
                                this.setState({password: input.target.value});
                              }}
                              type="password"
                              className="form-control"
                              placeholder="Mot de passe"
                              required
                              style={{height: 50}}
                            />
                          </label>
                          <label className="col-lg-12">
                            <input
                              id="Téléphone"
                              onChange={(input) => {
                                this.setState({phone: input.target.value});
                              }}
                              type="text"
                              className="form-control"
                              placeholder="Téléphone"
                              required
                              style={{height: 50}}
                            />
                          </label>
                        </div>

                        <div className="col-lg-6 col-sm-12">
                          {/* <label className="col-lg-12">
                          <input
                            id="NationalID"
                            onChange={(input) => {
                              this.setState({nationalId: input.target.value});
                            }}
                            type="text"
                            className="form-control"
                            placeholder="National ID"
                            required
                            style={{height: 50}}
                          />
                        </label>
                        <label className="col-lg-12">
                          <input
                            id="patenteID"
                            onChange={(input) => {
                              this.setState({patenteId: input.target.value});
                            }}
                            type="text"
                            className="form-control"
                            placeholder="Patente ID"
                            required
                            style={{height: 50}}
                          />
                        </label>
                         */}

                          <label className="col-lg-12">
                            <Select
                              placeholder={"Type d'activité"}
                              options={typeActivite}
                              onChange={(input) => {
                                console.log(input);

                                this.setState({activity: input});
                              }}
                            />
                          </label>
                          <label className="col-lg-12">
                            <Select
                              placeholder={"Categorie"}
                              options={
                                this.state.activity.value === "musique"
                                  ? optionsMusic
                                  : optionsArt
                              }
                              isMulti={true}
                              onChange={(input) => {
                                this.setState({category: input});
                              }}
                            />
                          </label>
                        </div>
                      </div>
                      <center>
                        <button
                          className="rn-button-style--2 btn-primary-color"
                          type="submit">
                          Envoyer
                        </button>
                      </center>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

class Main extends Component {
  render() {
    return (
      <div class="main-page active-dark">
        <main className="page-wrapper">
          <div className="rn-slider-area position-relative" id="home">
            <div id="particles-js"></div>
            <div className="slide slide-style-2 bg_image bg_image--27 d-flex align-items-center justify-content-center">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="inner text-center">
                      <h1
                        className="title theme-gradient"
                        style={{fontSize: 60, lineHeight: 1.5}}>
                        {" Byenvini nan V.I.L.A.J "}
                      </h1>
                      <h1
                        className="title "
                        style={{fontSize: 30, lineHeight: 1.5, color: "#fff"}}>
                        {"Kote kilti marye ak teknoloji"}
                      </h1>
                      {/* <p
                        className="description"
                        style={{
                          fontSize: 27,
                          fontWeight: "lighter",
                          marginTop: 20,
                        }}>
                        Pi bon mwayen pou asire yon demen miyò e asire lavni
                        timoun yo
                      </p> */}
                      <div className="slide-btn">
                        <a
                          style={{cursor: "pointer", color: "#fff"}}
                          className="rn-button-style--2 btn_solid "
                          data-toggle="modal"
                          data-target="#membreModal"
                          data-whatever="@getbootstrap">
                          Devenir membre
                        </a>
                      </div>

                      <div className="slide-btn">
                        <Link
                          style={{textDecoration: "none"}}
                          class="rn-button-style--2 btn_border"
                          to="/market">
                          VOIR LES OEUVRES
                        </Link>
                        {/* <a
                       
                          style={{
                            cursor: "pointer",
                            color: "#fff",
                            height: 55,
                            width: 300,
                          }}
                          className="btn btn-success btn-lg">
                          
                        </a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="rn-service-area rn-section-gap bg_color--1"
            id="service">
            <div className="container">
              <div className="row">
                <div class="col-lg-7 col-12">
                  <div class="section-title text-left mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                    <h2 class="title">Service</h2>
                    <p>
                      Afin de vous accompagner dans le processus la sécurisation
                      et la vente de vos oeuvres, nous vous offrons des options
                      simples et faciles à utiliser.
                    </p>
                    {/* <div class="service-btn">
                      <a
                        style={{textDecoration: "none"}}
                        class="btn-transparent rn-btn-dark"
                        href="http://rainbowit.net/service">
                        <span class="text">Request Custom Service</span>
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rn-service-area ptb--80 bg_image bg_image--3">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 col-12 mt_md--50">
                  <div class="row service-one-wrapper">
                    {/* Start Single Service  */}
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div class="single-service service__style--4">
                        <a style={{textDecoration: "none"}}>
                          <div class="service">
                            <div class="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-cast">
                                <path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path>
                                <line x1="2" y1="20" x2="2.01" y2="20"></line>
                              </svg>
                            </div>
                            <div class="content">
                              <h3 class="title">Enregistrement</h3>
                              <p>
                                Gagnez du temps en enregistrant vos oeuvres sans
                                vous déplacer en remplissant nos formulaires en
                                ligne, autorisés par le BHDA.
                              </p>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    {/* End Single Service  */}

                    {/* Start Single Service  */}
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div class="single-service service__style--4">
                        <a style={{textDecoration: "none"}}>
                          <div class="service">
                            <div class="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-layers">
                                <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                                <polyline points="2 17 12 22 22 17"></polyline>
                                <polyline points="2 12 12 17 22 12"></polyline>
                              </svg>
                            </div>
                            <div class="content">
                              <h3 class="title">Sécurisation</h3>
                              <p>
                                Nous utilisons la technologie Blockchain pour
                                horodater vos oeuvres et sauvegarder l'intégrité
                                de vos informations.
                              </p>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    {/* End Single Service  */}

                    {/* Start Single Service  */}
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div class="single-service service__style--4">
                        <a style={{textDecoration: "none"}}>
                          <div class="service">
                            <div class="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-users">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                              </svg>
                            </div>
                            <div class="content">
                              <h3 class="title">Distribution</h3>
                              <p>
                                Permettant au grand public d'avoir l'accès à vos
                                oeuvres via notre "Marketplace" afin de faire
                                plus de profit.
                              </p>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    {/* End Single Service  */}

                    {/* Start Single Service  */}
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div class="single-service service__style--4">
                        <a style={{textDecoration: "none"}}>
                          <div class="service">
                            <div class="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-monitor">
                                <rect
                                  x="2"
                                  y="3"
                                  width="20"
                                  height="14"
                                  rx="2"
                                  ry="2"></rect>
                                <line x1="8" y1="21" x2="16" y2="21"></line>
                                <line x1="12" y1="17" x2="12" y2="21"></line>
                              </svg>
                            </div>
                            <div class="content">
                              <h3 class="title">Monitoring</h3>
                              <p>
                                Ayez accès aux données de diffusions et
                                controlez les utilisations de vos oeuvres en
                                temps réel.
                              </p>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    {/* End Single Service  */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rn-counterup-area pt--100 pb--110 bg_color--1" style={{}}>
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <div class="section-title text-center">
                    <h3 class="fontWeight500">Nos chiffres</h3>
                  </div>
                </div>
              </div>
              <div class="row">
                {/*Start Single Counterup  */}
                <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <div class="rn-counterup counterup_style--1">
                    <h5 class="counter count">100</h5>
                    <p class="description">Auteurs</p>
                  </div>
                </div>
                {/*Start Single Counterup  */}

                {/*Start Single Counterup  */}
                <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <div class="rn-counterup counterup_style--1">
                    <h5 class="counter count">1000</h5>
                    <p class="description">Oeuvres</p>
                  </div>
                </div>
                {/*Start Single Counterup  */}

                {/*Start Single Counterup  */}
                <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                  <div class="rn-counterup counterup_style--1">
                    <h5 class="counter count">15K</h5>
                    <p class="description">Visiteurs/Mois</p>
                  </div>
                </div>
                {/*Start Single Counterup  */}
              </div>
            </div>
          </div>

          <div class="rn-blog-area rn-section-gapTop mb--100   bg_color--5">
            <div class="container">
              <div class="row align-items-end mb--20">
                <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="section-title text-left">
                    <h2>REJOIGNEZ-NOUS</h2>
                    <p>
                      Ces auteurs nous ont fait confiance pour proteger et
                      distribuer leurs oeuvres, vous attendez quoi pour nous
                      rejoindre?
                    </p>
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="blog-btn text-left text-lg-right mt_sm--10 mt_md--10">
                    <Link
                      class="btn-transparent rn-btn-dark"
                      to="/market"
                      style={{textDecoration: "none"}}>
                      <span class="text">Voir tous les autres</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div class="row">
                {/* Start Blog Area  */}
                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                  <div class="blog blog-style--1">
                    <div class="">
                      <a style={{textDecoration: "none"}}>
                        <img
                          style={{height: 400, objectFit: "cover"}}
                          class="w-100"
                          src="https://a4-images.myspacecdn.com/images04/7/ffa6a7bbd50747cea15bb70bfdf60520/600x600.jpg"
                          alt="Blog Images"
                        />
                      </a>
                    </div>
                    <div class="content">
                      <p class="blogtype">Chanteur / Compositeur</p>
                      <h4 class="title">
                        <a>John's H. Constant (Atis Constant)</a>
                      </h4>
                      <div class="blog-btn">
                        <a class="rn-btn text-white">Voir plus</a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End Blog Area  */}
                {/* Start Blog Area  */}
                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                  <div class="blog blog-style--1">
                    <div class="">
                      <a style={{textDecoration: "none"}}>
                        <img
                          style={{height: 400, objectFit: "cover"}}
                          class="w-100"
                          src="https://challengesnews.com/wp-content/uploads/2017/03/Cha-le_premier_album-_de_Jane-Placide-Luctong-16022017-1_RET.jpg"
                          alt="Blog Images"
                        />
                      </a>
                    </div>
                    <div class="content">
                      <p class="blogtype">Chanteuse</p>
                      <h4 class="title">
                        <a>Sarah Jane Rameau</a>
                      </h4>
                      <div class="blog-btn">
                        <a class="rn-btn text-white">Voir plus</a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End Blog Area  */}
                {/* Start Blog Area  */}
                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                  <div class="blog blog-style--1">
                    <div class="">
                      <a style={{textDecoration: "none"}}>
                        <img
                          style={{height: 400, objectFit: "cover"}}
                          class="w-100"
                          src="https://images.lenouvelliste.com/articles/2018-03-16/StevesJBryan_72.jpg"
                          alt="Blog Images"
                        />
                      </a>
                    </div>
                    <div class="content">
                      <p class="blogtype">Chanteur / Rappeur</p>
                      <h4 class="title">
                        <a>Steves Bryan Joseph (Steves J. Bryan)</a>
                      </h4>
                      <div class="blog-btn">
                        <a class="rn-btn text-white">Voir plus</a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End Blog Area  */}
              </div>
            </div>
          </div>

          <div class="rn-brand-area brand-separation">
            <div class="container">
              <br />
              <div class="row">
                <div class="col-lg-12">
                  <div class="section-title text-center">
                    <h3 class="fontWeight500">Partenaires</h3>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-lg-12">
                  <ul class="brand-style-2">
                    <li>
                      <img
                        src="https://www.auf.org/wp-content/uploads/2017/04/image-6337.jpg"
                        alt="Logo Images"
                      />
                    </li>
                    <li>
                      <img
                        src="https://haitibrand.co/wp-content/uploads/2020/02/Artboard7@3x_2-1.png"
                        alt="Logo Images"
                      />
                    </li>
                    <li>
                      <img
                        src="https://www.syntaxstudio.io/images/syntax-studio-blue.png"
                        alt="Logo Images"
                      />
                    </li>
                    <li>
                      <img
                        src="https://www.banjdev.com/images/BANJDEV.png"
                        alt="Logo Images"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>

        <footer class="footer-area footer-default">
          <div class="footer-wrapper">
            <div class="row align-items-end row--0">
              <div class="col-lg-6">
                <div class="footer-left">
                  <div class="inner">
                    <span></span>
                    <h2>Prêt pour l'aventure</h2>
                    {/* <a class="rn-button-style--2" href="contact.html">
                      <span>Contact Us</span>
                    </a> */}
                    <br /> <br /> <br />
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="footer-right" data-black-overlay="6">
                  <div class="row">
                    {/*Start Single Widget */}
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="footer-widget">
                        <h4>Lien rapide</h4>
                        <ul class="ft-link">
                          <li>
                            <a href="/market">Espace de vente</a>
                          </li>
                          <li>
                            <a href="">A propos</a>
                          </li>
                          <li>
                            <a href="">Contactez-nous</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/*End Single Widget  */}
                    {/*Start Single Widget */}
                    <div class="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                      <div class="footer-widget">
                        <h4>Contactez-nous</h4>
                        <ul class="ft-link">
                          <li>
                            <a href="mailto:hello@vilaj.ht">hello@vilaj.ht</a>
                          </li>
                        </ul>

                        <div class="social-share-inner">
                          <ul class="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                            {/* <li>
                              <a href="#">
                                <i class="fab fa-facebook-f"></i>
                              </a>
                            </li> */}
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/*End Single Widget  */}

                    <div class="col-lg-12">
                      <div class="copyright-text">
                        <p>Copyright © 2020 VILAJ. Tous droits réservés</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    stats: state.user.stats,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    login: (data) => {
      dispatch(login(data));
    },
    register: (data) => {
      dispatch(register(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
